// ============================================================
// RAMLJAK — AUTO DETAILING CENTAR · sadržaj stranice
// ZAMJENA FOTOGRAFIJA: zamijenite URL-ove u ovoj datoteci
// stvarnim fotografijama (npr. "/images/rad-01.jpg" iz public/images).
// "Prije/Poslije": stavite prave before/after fotografije u BA_CASES
// (beforeSrc / afterSrc) — dok ne postoje, "prije" se prikazuje
// automatski zatamnjeno.
// ============================================================

export const BRAND = "RAMLJAK";
export const BRAND_SUB = "AUTO DETAILING CENTAR";
export const PHONE_SHORT = "063 640 050";
export const PHONE_DISPLAY = "+387 63 640 050";
export const PHONE_TEL = "tel:+38763640050";
export const PHONE2_SHORT = "063 522 335";
export const PHONE2_TEL = "tel:+38763522335";
export const EMAIL = "mislav-ramljak@hotmail.com";
export const EMAIL_MAILTO = "mailto:mislav-ramljak@hotmail.com";
export const MAPS_URL = "https://maps.app.goo.gl/2zMh6MGEH4rkaogc6";
export const WHATSAPP_URL = "https://wa.me/38763640050";
export const FACEBOOK_URL =
    "https://www.facebook.com/ramljakautodetailingcentar/";
export const INSTAGRAM_URL =
    "https://www.instagram.com/ramljak_auto_detailing_centar/";
export const MAP_EMBED =
    "https://www.google.com/maps?q=Ramljak%20Auto%20Detailing%20Centar%2C%20Ulica%20Hrvatskih%20kraljeva%2035%2C%2088320%20Ljubu%C5%A1ki&output=embed";
export const ADDRESS_1 = "Ulica Hrvatskih kraljeva 35";
export const ADDRESS_2 = "88320 Ljubuški, BiH";
export const CITY = "Ljubuški";

export const NAV_LINKS = [
    { label: "POČETNA", to: "/", id: "pocetna" },
    { label: "USLUGE", to: "/usluge", id: "usluge" },
    { label: "RADOVI", to: "/radovi", id: "radovi" },
    { label: "KONTAKT", to: "/kontakt", id: "kontakt" },
];
export const BOOKING_PATH = "/termin";

export const HOURS = [
    { days: "Ponedjeljak – Petak", time: "08:00 – 17:00" },
    { days: "Subota", time: "08:00 – 14:00" },
    { days: "Nedjelja", time: "Zatvoreno" },
];

const u = (id, w = 1400) =>
    `https://images.unsplash.com/${id}?w=${w}&q=80&auto=format&fit=crop`;

export const IMG = {
    opening: "/images/rad-07.jpg",
    statement: u("photo-1556189250-72ba954cfc2b", 1400),
};

export const BA_CASES = [
    {
        id: "farovi",
        label: "Poliranje farova",
        before: "/images/prije-far.jpg",
        after: "/images/poslije-far.jpg",
        alt: "Matirani far prije i obnovljeni far poslije poliranja",
    },
    {
        id: "eksterijer",
        label: "Eksterijer",
        src: u("photo-1511919884226-fd3cad34687c", 1800),
        alt: "Vanjski izgled vozila prije i poslije detaljne obrade",
    },
    {
        id: "interijer",
        label: "Interijer",
        src: u("photo-1523983388277-336a66bf9bcd", 1800),
        alt: "Interijer vozila prije i poslije dubinskog čišćenja",
    },
];

export const SERVICES = [
    {
        num: "01",
        title: "DUBINSKO ČIŠĆENJE",
        desc: "Temeljito čišćenje interijera — sjedala, tepisi, podovi i svaka unutrašnja površina.",
        image: u("photo-1605437241278-c1806d14a4d9", 1600),
        alt: "Dubinsko čišćenje kožnog interijera",
    },
    {
        num: "02",
        title: "POLIRANJE",
        desc: "Obrada vanjskih površina za dubok sjaj i uredan završetak laka.",
        image: u("photo-1620584898989-d39f7f9ed1b7", 1600),
        alt: "Poliranje laka vozila",
    },
    {
        num: "03",
        title: "AUTO DETAILING",
        desc: "Potpuna njega vozila, iznutra i izvana — detalj po detalj, uključujući keramičku zaštitu.",
        image: u("photo-1605559424843-9e4c228bf1c2", 1600),
        alt: "Vozilo nakon kompletnog detailinga",
    },
    {
        num: "04",
        title: "ODRŽAVANJE VOZILA",
        desc: "Plan njege prilagođen vašem vozilu i navikama — po dogovoru.",
        image: u("photo-1508974239320-0a029497e820", 1600),
        alt: "Redovita njega vozila",
    },
];

export const MOTION_PANELS = [
    { word: "CLEAN.", label: "Dubinsko čišćenje", image: u("photo-1608259243654-70c070e0f6ed", 1400), alt: "Čišćenje interijera vozila" },
    { word: "CORRECT.", label: "Obrada laka", image: u("photo-1620584898989-d39f7f9ed1b7", 1400), alt: "Strojna obrada laka" },
    { word: "REFINE.", label: "Njega detalja", image: u("photo-1656077885491-3922185f3932", 1400), alt: "Njega unutrašnjih detalja" },
    { word: "FINISH.", label: "Završni sjaj", image: u("photo-1519440862171-af26cf8c2a85", 1400), alt: "Završni sjaj karoserije" },
];

export const PRINCIPLES = [
    { word: "PRECISION", desc: "Pažnja prema detaljima." },
    { word: "PATIENCE", desc: "Bez preskakanja koraka." },
    { word: "CARE", desc: "Vozilo dobiva pažnju koju zaslužuje." },
    { word: "RESULT", desc: "Rezultat mora biti vidljiv." },
];

// Prave fotografije Ramljak radova (početna — "Odabrani radovi").
// Zamjena: prebaci novu sliku u public/images/ i promijeni putanju ovdje.
export const FEATURED_WORKS = [
    {
        src: "/images/rad-01.jpg",
        alt: "Crni BMW M4 nakon detailinga ispred Ramljak centra",
    },
    {
        src: "/images/rad-02.jpg",
        alt: "Dubinski očišćen Mercedes-AMG interijer",
    },
    {
        src: "/images/rad-03.jpg",
        alt: "Zlatni Lamborghini Huracán nakon obrade laka",
    },
];

// Prave fotografije Ramljak radova (stranica RADOVI).
// Zamjena/dodavanje: prebaci sliku u public/images/ i dodaj stavku ovdje.
export const WORKS = [
    { src: "/images/rad-01.jpg", alt: "Crni BMW M4 nakon detailinga ispred Ramljak centra" },
    { src: "/images/rad-08.jpg", alt: "Očišćeni Mercedes-AMG SL interijer s kožom boje konjaka" },
    { src: "/images/rad-05.jpg", alt: "Crna Mercedes S-klasa nakon poliranja laka" },
    { src: "/images/rad-04.jpg", alt: "Sivi Mercedes-AMG GLS nakon detailinga" },
    { src: "/images/rad-07.jpg", alt: "Refleksija na poliranom laku crnog BMW-a" },
    { src: "/images/rad-03.jpg", alt: "Zlatni Lamborghini Huracán nakon obrade laka" },
    { src: "/images/rad-06.jpg", alt: "Bijeli Mercedes-AMG SL nakon detailinga" },
    { src: "/images/rad-02.jpg", alt: "Dubinski očišćen Mercedes-AMG interijer" },
];
